import moment from 'moment'
export default {
  methods: {
    _moment (v) {
      return moment(v)
    },
    _elapsedColor (percent) {
      return percent < 50
        ? 'info'
        : percent < 75
          ? 'warning'
          : 'error'
    },
    _dueDate (duration, timestamp) {
      timestamp = timestamp ? moment(timestamp) : moment()
      return timestamp.add(moment.duration(Number(duration), 'hours')).format('DD-MMM-YYYY')
    },
    _timeLeft (start, duration) {
      return moment.duration(moment(start).add(duration, 'hours').diff(moment())).asHours()
    },
    _elapsedPercent (start, duration) {
      let _timeLeft = this._timeLeft(start, duration)
      return (((Number(duration) - _timeLeft)) / Number(duration)) * 100
    },
    _timeLeftText (start, duration) {
      if (!start || !duration) return ''
      let _timeLeft = this._timeLeft(start, duration)
      // let totalHours = _timeLeft.asHours()
      if (_timeLeft > 24) {
        let days = Math.floor(_timeLeft / 24)
        let hours = Math.floor(_timeLeft - (days * 24))
        return `${days}D ${hours}h`
      } else {
        return `${Math.floor(_timeLeft)}h`
      }
    }
  }
}
